import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Store } from '@ngneat/elf';
import { SelectItem } from 'primeng/api';

@Component({
    selector: 'app-single-load-results',
    template: `
      <div class="space-x-2">
        <p-select
          [options]="loadCases"
          [ngModel]="selectedLoadCase"
          optionLabel="label"
          (onChange)="onLoadCaseSelected($event)"
          appendTo="body"
        ></p-select>
        @if (isAxialForce) {
          <span>
            <i pTooltip="Forces with bending. Results for forces without bending are accessible in Forces/Displacements results" class="pi pi-info-circle cursor-help relative z-[2]"></i>
          </span>
        }
      </div>
    `,
    standalone: false
})
export class SingleLoadResultsComponent implements OnChanges {

  @Input() isAxialForce: boolean;
  @Input() loadCases: SelectItem[] = [];
  @Input() signalRChange: boolean;
  @Input() stateStore: Store;

  @Output() loadCaseSelected = new EventEmitter<Event>();

  public selectedLoadCase: any;

  ngOnChanges(): void {
    // Sync local property from store
    this.selectedLoadCase = this.stateStore.state?.selectedLoadCase;

    if (!this.signalRChange && !this.selectedLoadCase) {
      this.selectedLoadCase = this.loadCases[0];
      this.stateStore.update(state => ({...state, selectedLoadCase: this.selectedLoadCase}));
    }
  }

  onLoadCaseSelected(event: any): void {
    this.selectedLoadCase = event.value;
    this.stateStore.update(state => ({...state, selectedLoadCase: event.value}));
    this.loadCaseSelected.emit(event);
  }
}
